import { z } from "zod";

const personaBaseSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  initials: z.string().min(1).max(3),
});

export const employeePersonaSchema = personaBaseSchema.extend({
  kind: z.literal("employee"),
  roleId: z.string().min(1),
  onboardingComplete: z.boolean(),
  workContext: z.string().nullable(),
});

export const supervisorPersonaSchema = personaBaseSchema.extend({
  kind: z.literal("supervisor"),
  title: z.string().min(1),
});

export const adminPersonaSchema = personaBaseSchema.extend({
  kind: z.literal("admin"),
  title: z.string().min(1),
});

export const personaSchema = z.discriminatedUnion("kind", [
  employeePersonaSchema,
  supervisorPersonaSchema,
  adminPersonaSchema,
]);

export type EmployeePersona = z.infer<typeof employeePersonaSchema>;
export type SupervisorPersona = z.infer<typeof supervisorPersonaSchema>;
export type AdminPersona = z.infer<typeof adminPersonaSchema>;
export type Persona = z.infer<typeof personaSchema>;
